<template>
  <div class="barBox" ref="chart"></div>
</template>

<script>
import echarts from 'echarts'
import debounce from '@/utils/debounce'

export default {
  name: 'barDemo',
  data () {
    return {
      myChart: null,
      defaultOptions: {
        tooltip: {
          trigger: 'axis'
        },
        grid: { top: '', right: '', bottom: '', left: '' },
        legend: {
          itemWidth: 10,
          itemHeight: 2,
          icon: 'rect',
          padding: [-15, 0, 0, 0],
          textStyle: {
            color: '#8794A4 '
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: [],
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              color: '#253B4B '
            }
          },
          axisLabel: {
            rotate: '35',
            color: '#8794A4  '
          }
        },
        yAxis: [
          {
            name: '',
            scale: true,
            min: 0,
            axisLine: {
              show: false,
              lineStyle: {
                color: '#8794A4 '
              }
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#253B4B '
              }
            },
            axisTick: {
              show: false
            }
          },
          {
            name: '',
            scale: true,
            min: 0,
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '',
            type: 'line',
            data: [],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#2A4CD8  ' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: '#09101C  ' // 100% 处的颜色
                  }
                ])
              }
            }
          },
          {
            name: '',
            type: 'line',
            data: []
          },
          {
            name: '',
            type: 'line',
            data: []
          }
        ]
      }
    }
  },
  props: {
    chartData: {
      default: () => {}
    }
  },
  mounted () {
    this.resizeData(this.chartData)
  },
  methods: {
    resizeChange () {
      window.addEventListener('resize', debounce(this.myChart.resize, 200))
    },
    resizeData (val) {
      let _this = this
      this.defaultOptions.grid.top = val.padding[0]
      this.defaultOptions.grid.right = val.padding[1]
      this.defaultOptions.grid.bottom = val.padding[2]
      this.defaultOptions.grid.left = val.padding[3]
      this.defaultOptions.xAxis.data = val.xAxisData
      this.defaultOptions.color = val.color
      val.series.map((i, index) => {
        _this.defaultOptions.series[index].name = i.name
        _this.defaultOptions.series[index].type = i.type || 'line'
        _this.defaultOptions.series[index].type = i.type || 'line'
        _this.defaultOptions.series[index].barWidth = i.barWidth || 5
        _this.defaultOptions.series[index].data = i.data
      })
      this.defaultOptions.legend.top = 20
      // let color0 = this.defaultOptions.series[0].areaStyle.normal.color
      // let color1 = this.defaultOptions.series[1].areaStyle.normal.color
      // for (var i = 0; i < 2; i++) {
      //   color0.colorStops[i].color = val.colorStops1[i]
      //   color1.colorStops[i].color = val.colorStops2[i]
      // }
      this.myChart = echarts.init(this.$refs.chart)
      this.myChart.setOption(this.defaultOptions)
      this.resizeChange()
    }
  },
  watch: {
    chartData (val) {
      this.defaultOptions.xAxis.data = val.xAxisData
      val.series.map((i, index) => {
        this.defaultOptions.series[index].name = i.name
        this.defaultOptions.series[index].data = i.data
      })
      if (val.yAxis) {
        this.defaultOptions.yAxis = val.yAxis
      }
      this.myChart.setOption(this.defaultOptions)
    }
  }
}
</script>

<style lang="scss" scpoed>
.barBox {
  width: 100%;
  height: 100%;
}
</style>
